import { settingsTexts } from 'consts/text';
import { AbsenceReportType, LabelMapper } from 'types';

export const absenceReportTypeLabels: LabelMapper<AbsenceReportType> = {
    PREVIOUS_DAY: settingsTexts.settlements.meals.formLabels.previousDay,
    CURRENT_DAY: settingsTexts.settlements.meals.formLabels.currentDay,
};
